"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferHandler = exports.transfer = void 0;
var instance_1 = require("./instance");
var msw_1 = require("msw");
var mock = {};
function transfer(transfer) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/Transfer",
        method: "POST",
        data: transfer,
    })
        .then(function (result) { return result.status; });
}
exports.transfer = transfer;
mock.transfer = function () {
    return msw_1.rest.post("".concat((0, instance_1.getBaseURL)(), "/Transfer"), function (req, res, ctx) {
        return res(ctx.status(200));
    });
};
exports.transferHandler = mock;
